import { CUSTOM_RESPONSE } from './constants'
import { ContentCarousel } from '../../ContentCarousel'
import { SmartTable } from '../../SmartTable'
import { ContentCarouselNav } from '../../ContentCarouselNav'
import { ContentCarouselGallery } from '../../ContentCarouselGallery'
import VirtualTourInterior from '../../components/virtual-tour/components/assistant-card-interior'
import VirtualTourExterior from '../../components/virtual-tour/components/assistant-card-exterior'
import SoundSystem from '../../components/blueprint/sound-system'
import Safety from '../../components/blueprint/safety'
import { CarouselGalleryAsset } from '../../components/carousel-gallery/CarouselGalleryAsset'

export function returnCustomComponentFromType(type, message) {
  switch (type) {
    case CUSTOM_RESPONSE.VIRTUAL_TOUR_INTERIOR:
      return <VirtualTourInterior />
    case CUSTOM_RESPONSE.VIRTUAL_TOUR_EXTERIOR:
      return <VirtualTourExterior />
    case CUSTOM_RESPONSE.BLUEPRINT_SOUND_SYSTEM:
      return <SoundSystem />
    case CUSTOM_RESPONSE.BLUEPRINT_SAFETY:
      return <Safety />
    case CUSTOM_RESPONSE.CAROUSEL:
      return <ContentCarousel />
    case CUSTOM_RESPONSE.CAROUSEL_NAV:
      const carousel_input = message['user_defined']['carousel_data']
      return <ContentCarouselNav carouselData={carousel_input} />
    // return <ContentCarouselNav/>
    case CUSTOM_RESPONSE.CAROUSEL_GALLERY:
      return <ContentCarouselGallery />
    case CUSTOM_RESPONSE.CAROUSEL_GALLERY_ASSET:
      const carouselData = message['user_defined']['carousel_data']
      return <CarouselGalleryAsset carouselItems={carouselData} />
    // return <ContentCarouselNav/>
    case CUSTOM_RESPONSE.SMART_TABLE:
      const input2 = message['user_defined']['smart_table_data']
      return <SmartTable smartTableData={input2} />
    default:
      return null
  }
}
